import React, {useState} from "react";
import { Link } from "gatsby"

import "./navigation.scss"

const pageLinks = [
    { text: "Collection", url: "/collection" },
    { text: "Prelaunch", url: "/prelaunch" },
    { text: "Prizes", url: "/prizes" },
    { text: "Staking", url: "/staking" },
    { text: "ERC-404", url: "/erc404" },
  ]

const Navigation = () => {
    const [open, setOpen] = useState(false)

    return <nav id="main-nav" role="navigation" aria-label="Main">
        <div className={`nav-group${open ? " open" : ""}`}>
            <Link className="home" activeClassName="active" to="/">
                <span className="mobile">Home</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.6 23.36">
                    <polygon points="24.04 11.64 12.3 1.11 .55 11.64 0 11.03 12.3 0 24.6 11.03 24.04 11.64"/>
                    <path d="M21.83,11.86L12.3,3.32,2.76,11.86v11.49h19.07v-11.49ZM15.2,22.53h-5.8v-7.46c0-1.37,1.12-2.49,2.49-2.49h.83c1.37,0,2.49,1.12,2.49,2.49v7.46ZM16.03,22.53v-7.46c0-1.83-1.49-3.32-3.32-3.32h-.83c-1.83,0-3.32,1.49-3.32,3.32v7.46H3.59v-10.29l8.71-7.8,8.7,7.8v10.29s-4.97,0-4.97,0Z"/>
                </svg>
            </Link>
            {pageLinks.map((link) => (
                <React.Fragment key={link.url}>
                    <Link activeClassName="active" to={link.url}>{link.text}</Link>
                </React.Fragment>
            ))}
        </div>
        <a href="https://airdrop.marinemoguls.com" className="button airdrop">Airdrop</a>
        <button className={`burger mobile${open ? " open" : ""}`} onClick={() => setOpen(!open)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
            </svg>
        </button>
    </nav>
}
export default Navigation